<script>
import baseStore from '@/stores/Store.js'
export default {
  name: 'Abstract',
  methods: {
    getCurrentRouteAnimation() {
      return baseStore.getters.currentAnimation
    },
  },
}
</script>

<template lang="pug">
.route-view
  transition(:name="getCurrentRouteAnimation()")
    router-view
</template>
